import React, { memo, useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import Text from 'components/core/Text';
import { updateUser } from 'actions/user';
import useDeviceKind from 'hooks/useDeviceKind';
import { TIMEZONES } from '../../../../constants';
import { Wrapper, StyledSelect, NativeSelectContainer, StyledNativeSelect } from './styles';

const formattedTimezones = TIMEZONES.map((timezone) => {
  return {
    label: timezone.text,
    value: timezone.text,
    offsetValue: timezone.offset,
  };
});

const TimezoneSelect = () => {
  const userId = useSelector((state) => state.user.id);
  const userSettings = useSelector((state) => state.user.settings);
  const isDesktop = useDeviceKind('desktop');

  const [selectedOption, changeSelectedOption] = useState(null);
  useEffect(() => {
    if (!userSettings) {
      return;
    }
    changeSelectedOption(
      formattedTimezones.find((timezone) => timezone.value === userSettings.timeZoneText),
    );
  }, [userSettings]);

  const dispatch = useDispatch();
  const handleChange = useCallback(
    (newValue) => {
      changeSelectedOption(newValue);
      dispatch(
        updateUser({
          data: {
            id: userId,
            settings: {
              ...userSettings,
              timeZone: newValue.offsetValue,
              timeZoneText: newValue.value,
            },
          },
        }),
      );
    },
    [dispatch, userId, userSettings],
  );

  const handleNativeEvent = useCallback(
    (event) => {
      const { value } = event.target;
      const newSelectedOption = formattedTimezones.find((timezone) => timezone.value === value);

      if (newSelectedOption) {
        handleChange(newSelectedOption);
      }
    },
    [handleChange],
  );

  return (
    <Wrapper>
      <Text variant="sectionHeader" tag="h4" weight="normal">
        Time Zone
      </Text>
      <StyledSelect>
        {isDesktop ? (
          <Select
            instanceId="timezone"
            dropdownIndicator={false}
            className="react-select-container"
            classNamePrefix="react-select"
            value={selectedOption}
            onChange={handleChange}
            options={formattedTimezones}
            menuPlacement={isDesktop ? 'top' : 'auto'}
            placeholder="(UTC-05:00) Eastern Time (US & Canada)"
          />
        ) : (
          <NativeSelectContainer>
            {!!selectedOption && (
              <StyledNativeSelect onChange={handleNativeEvent} defaultValue={selectedOption?.value}>
                {formattedTimezones &&
                  formattedTimezones.map((timezone) => (
                    <option key={timezone.value} value={timezone.value}>
                      {timezone.label}
                    </option>
                  ))}
              </StyledNativeSelect>
            )}
          </NativeSelectContainer>
        )}
      </StyledSelect>
    </Wrapper>
  );
};

export default memo(TimezoneSelect);
